module.exports = __webpack_public_path__ + "static/img/systemli2.0f4877a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/scheme/systemli2.png
// module id = L9mA
// module chunks = 1